const deliverables = [
  {
    icon: 'ri-microscope-line',
    badge: '01',
    title: 'Маркетинговый рентген (Смыслы)',
    subtitle: 'Анализ торгового предложения',
    text: 'Разбор вашего торгового предложения и позиционирования. Насколько вы убедительны? Получите чёткий ответ с конкретными рекомендациями по улучшению.',
    tag: 'Смыслы и оффер',
  },
  {
    icon: 'ri-route-fill',
    badge: '02',
    title: 'Технический и UX-тест',
    subtitle: 'Юзабилити, удобство использования',
    text: 'Путь клиента от входа до заявки. Проверка кнопок, форм и верстки по 208 пунктам. Выявление всех точек потери пользователя.',
    tag: 'UX / Техника',
  },
  {
    icon: 'ri-spy-line',
    badge: '03',
    title: 'Конкурентная разведка',
    subtitle: 'Сравнение с лидерами рынка',
    text: 'Сравнение вашей страницы с 5 лидерами рынка. В чём они выигрывают прямо сейчас? Получите чёткое понимание своего места в конкурентной среде.',
    tag: '5 конкурентов',
  },
  {
    icon: 'ri-file-list-3-line',
    badge: '04',
    title: 'Итоговый PDF-отчёт',
    subtitle: 'Карта исправлений',
    text: 'Вы получаете не критику, а пошаговую «карту исправлений» с конкретными рекомендациями — что изменить в текстах или дизайне для роста вашей прибыли.',
    tag: 'PDF-документ',
    highlight: true,
  },
];

export default function AuditProcess() {
  return (
    <section className="py-16 md:py-24 bg-[#1A2B4C] relative overflow-hidden">
      {/* Decorative */}
      <div className="hidden md:block absolute top-0 left-1/2 w-px h-full bg-[#C5A880]/10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/30 rounded-full px-4 sm:px-5 py-2 mb-5 md:mb-6">
            <i className="ri-gift-line text-[#C5A880] text-sm"></i>
            <span className="text-[#C5A880] text-xs sm:text-sm font-semibold font-['Montserrat'] uppercase tracking-widest">результат</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 md:mb-6 font-['Playfair_Display'] leading-tight">
            Что вы получите в результате аудита?
          </h2>
          <div className="w-20 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        {/* Deliverables */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {deliverables.map((item) => (
            <div
              key={item.badge}
              className={`rounded-3xl p-5 sm:p-8 border transition-all duration-300 group ${
                item.highlight
                  ? 'bg-[#C5A880]/15 border-[#C5A880] hover:bg-[#C5A880]/20'
                  : 'bg-white/5 border-white/10 hover:border-[#C5A880]/40 hover:bg-white/8'
              }`}
            >
              <div className="flex items-start gap-4 sm:gap-5">
                <div className="flex flex-col items-center gap-2 flex-shrink-0">
                  <div className={`flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-2xl ${item.highlight ? 'bg-[#C5A880]' : 'bg-[#C5A880]/20 group-hover:bg-[#C5A880]'} transition-all duration-300`}>
                    <i className={`${item.icon} text-xl sm:text-2xl ${item.highlight ? 'text-[#1A2B4C]' : 'text-[#C5A880] group-hover:text-[#1A2B4C]'} transition-colors duration-300`}></i>
                  </div>
                  <span className={`text-xs font-bold font-['Montserrat'] ${item.highlight ? 'text-[#C5A880]' : 'text-white/30'}`}>
                    {item.badge}
                  </span>
                </div>
                <div className="flex-1">
                  <div className={`inline-block text-xs font-semibold font-['Montserrat'] px-3 py-1 rounded-full mb-3 ${item.highlight ? 'bg-[#C5A880] text-[#1A2B4C]' : 'bg-white/10 text-white/50'}`}>
                    {item.tag}
                  </div>
                  <h3 className="text-white font-bold text-base sm:text-lg mb-1 font-['Playfair_Display']">{item.title}</h3>
                  <p className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] mb-3 italic">{item.subtitle}</p>
                  <p className="text-white/65 text-sm leading-relaxed font-['Montserrat'] text-justify">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-8 md:mt-10 text-center">
          <div className="inline-flex items-center gap-3 bg-white/5 border border-[#C5A880]/20 rounded-2xl px-5 sm:px-8 py-4">
            <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0">
              <i className="ri-calendar-check-line text-[#C5A880] text-xl sm:text-2xl"></i>
            </div>
            <p className="text-white/70 font-['Montserrat'] text-sm">
              Срок выполнения: <strong className="text-[#C5A880]">2–3 рабочих дня</strong> с момента оплаты
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
